import React, { Component } from 'react';
import { array, arrayOf, bool, func, number, oneOfType, shape, string } from 'prop-types';
import { formatCurrency } from '../../lib/formatters';

export default class CompSetsTile extends Component {
  static propTypes = {
    data: shape({
      company_type: string,
      competitive_set_name: string,
      competitive_set_pk: number,
      creation_time: string,
      creator_user_id: oneOfType([string, number]),
      default_job_families: arrayOf(
        shape({
          label: string,
          value: string
        })
      ),
      employees_count: number,
      government_contractor: bool,
      industry: array,
      job_family_list: arrayOf(
        shape({
          label: string,
          value: string
        })
      ),
      last_modified_time: string,
      last_modifying_user_id: oneOfType([string, number]),
      total_revenue: number
    }),
    deleteAlert: func,
    editSet: func,
    getJobFamilyListForSet: func
  };

  constructor(props) {
    super(props);

    this.deleteAlert = this.deleteAlert.bind(this);
    this.editSet = this.editSet.bind(this);
    this.formatSelectedJobFamilies = this.formatSelectedJobFamilies.bind(this);
    this.renderActionIcon = this.renderActionIcon.bind(this);
    this.renderSectionData = this.renderSectionData.bind(this);
    this.renderSectionHeader = this.renderSectionHeader.bind(this);
  }

  deleteAlert() {
    const { data, deleteAlert } = this.props;

    deleteAlert(data);
  }

  editSet() {
    const { data, editSet, getJobFamilyListForSet } = this.props;

    getJobFamilyListForSet(data.competitive_set_pk).then(results => {
      data.job_family_list = results.map(res => {
        return { label: res.family, value: res.family };
      });

      editSet(data);
    });
  }

  formatSelectedJobFamilies(families) {
    return families.map(({ value }) => value).join(', ');
  }

  renderActionIcon(icon, action) {
    return <span className={`compsets__action-icon pointer ${icon}`} onClick={action} />;
  }

  renderSectionHeader(icon, label) {
    return (
      <div className="col-md-6">
        <i className={`compsets__label-icon ${icon}`} />
        <span className="compsets__tile-label">{label}</span>
      </div>
    );
  }

  renderSectionData(data) {
    return (
      <div className="col-md-6">
        <span className="compsets__tile-content">{data}</span>
      </div>
    );
  }

  render() {
    const { data, deleteAlert } = this.props;

    if (!data) return null;

    const {
      company_type,
      competitive_set_name,
      default_job_families,
      employees_count,
      government_contractor,
      industry,
      total_revenue
    } = data;
    const job_family = default_job_families ? this.formatSelectedJobFamilies(default_job_families) : '';
    const isLab = window.app.basicProductName !== 'MarketPay';

    return (
      <div className="compsets__tile">
        <div className="row">
          <h4 className="col-md-10 compsets__tile-title">{competitive_set_name}</h4>
          <div className="col-md-2 compsets__tile-actions">
            {this.renderActionIcon('icon-pencil', this.editSet)}
            {this.renderActionIcon('icon-trash', this.deleteAlert)}
          </div>
        </div>
        <div className="row">
          {this.renderSectionHeader('icon-building-filled', 'Organization Type')}
          {this.renderSectionData(company_type)}
        </div>
        <div className="row">
          {this.renderSectionHeader('icon-users', 'Number of Employees')}
          {this.renderSectionData(formatCurrency(employees_count, true, true))}
        </div>
        <div className="row">
          {this.renderSectionHeader(isLab ? 'fa fa-money' : 'icon-money', 'Total Revenue')}
          {this.renderSectionData(formatCurrency(total_revenue, true, false))}
        </div>
        <div className="row industry">
          {this.renderSectionHeader('icon-labormarket', 'Industry')}
          {this.renderSectionData(industry && industry.length > 0 ? industry[0] : null)}
        </div>
        <div className="row">
          {this.renderSectionHeader(isLab ? 'fa fa-bank' : 'icon-v-card', 'Government Contractor')}
          {this.renderSectionData(government_contractor ? 'Yes' : 'No')}
        </div>
        <div className="row">
          {this.renderSectionHeader('icon-archive', 'Job Family')}
          {this.renderSectionData(job_family)}
        </div>
      </div>
    );
  }
}
